
<div>
  <PageHeader>
    <div class="row ml-3">
      <div class="ml-1" v-if="isSuperAdmin">
        <div class="badgebutton active" @click="createBoard()">
          <i class="far fa-plus"></i>
          Create Board
        </div>
      </div>

      <div class="ml-3">
        <div class="badgebutton active" @click="createSpecialOccurrence()">
          <i class="far fa-plus"></i>
          Create Special Occurrence
        </div>
      </div>
    </div>

    <template v-slot:right>
      <router-link class="mt-2 mb-2" :to="{ name: routes.specialOccurrence.overview }">
        <div class="btn btn-primary c-white btn-sm mr-1">
          <i class="fa fa-history"></i>
          Special Occurrence Archive
        </div>
      </router-link>

      <user-time-zone></user-time-zone>

      <router-link
        tag="div"
        :to="{ name: routes.notificationsettings }"
        class="badgebutton info active text-nowrap ml-2"
        v-b-tooltip
        title="User Settings"
      >
        <i class="far fa-user"></i>
      </router-link>

      <router-link
        tag="div"
        :to="{ name: isAdmin ? routes.labels.generalLabels.name : routes.generalSettings.materialRequest.name }"
        class="badgebutton info active text-nowrap ml-2"
        v-b-tooltip
        title="General Settings"
        v-if="isAdmin || isMaterialRequestAdmin"
      >
        <i class="far fa-cogs"></i>
      </router-link>
    </template>
  </PageHeader>

  <div class="container">
    <!-- Boards -->
    <div>
      <div class="item-title mt-3">Boards</div>

      <div class="row" v-if="availableBoards.length">
        <div class="col-3" v-for="board in availableBoards" :key="board.id">
          <router-link class="navigation-card navigation-card-board mt-3 mb-2" tag="a" :to="{ name: 'Board', params: { id: board.id } }">
            <div class="navigation-card-title">
              <div>
                {{ board.title }}
                <span v-if="board.enableShifts">
                  <i class="far fa-clock"></i>
                </span>
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <div v-else>
        <div class="d-flex align-items-center justify-content-center mt-4">
          <div class="no-access-error">No boards available</div>
        </div>
      </div>
    </div>

    <!-- Special Occurrences -->
    <div>
      <div class="item-title mt-4 d-flex justify-content-between align-items-center">
        <span>Active Special Occurrences</span>
      </div>

      <div class="text-center" v-if="occurrencesLoading">
        <loading-spinner></loading-spinner>
      </div>

      <div v-else>
        <div class="row pl-4 pr-4" v-if="occurrences.length">
          <table class="os-table table table-striped table-hover mt-3 bg-white border" v-if="occurrences.length">
            <thead>
              <tr>
                <th scope="col">Type</th>
                <th scope="col">Type</th>
                <th scope="col">Aircraft</th>
                <th scope="col">Name</th>
                <th scope="col">Link</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="so in occurrences" :key="so.id" @click.stop="navigateToOccurrence(so, so.id)" class="cursor-pointer">
                <td class="os-table-type container-with-required-warn" scope="col">
                  <div class="d-flex">
                    {{ so.type }}
                  </div>
                  <i
                    class="far fa-info-circle required-warn"
                    v-if="!so.isOccurrenceFulFilled"
                    :title="publicConstants.notAllMandatoryFieldsFilled"
                    v-b-tooltip:hover
                  />
                </td>
                <td>
                  <div v-if="so.technicalOccurrenceType" :class="so.technicalOccurrenceType.cssClass" class="badge badgebutton">
                    {{so.technicalOccurrenceType?.name}}
                  </div>
                </td>
                <td>
                  <div v-if="so.aircraftRegistration" class="badge badgebutton active">
                    {{so.aircraftRegistration}}
                  </div>
                </td>
                <th class="os-table-name" scope="col">{{ so.name }}</th>
                <th class="os-table-name" scope="col">
                  <button class="badgebutton active" @click.stop="navigateToOccurrence(so, so.id)">Open</button>
                  <button
                    v-if="so.linkedMaterialRequestId"
                    class="badgebutton active ml-2"
                    @click.stop="navigateToMaterialRequest(so.linkedMaterialRequestId)"
                  >
                    Material Request
                  </button>
                </th>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-else>
          <div class="d-flex align-items-center justify-content-center mt-4">
            <div class="no-access-error">There are currently no Special Occurrences</div>
          </div>
        </div>
      </div>
    </div>

    <AppInfo />
  </div>
  <b-modal ref="newBoard" id="newBoard" body-class="modal-body-wo" hide-footer hide-header size="lg" title="Add new Board">
    <add-board></add-board>
  </b-modal>

  <b-modal
    ref="newSpecialOccurrence"
    id="newSpecialOccurrence"
    body-class="modal-body-wo"
    hide-footer
    hide-header
    size="l"
    title="Add new Special Occurrence"
  >
    <add-special-occurrence></add-special-occurrence>
  </b-modal>
</div>
